import type { IconSvgObject } from './types';

const BitcoinRectangleIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.50039L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50039C21.5 3.39584 20.6046 2.50041 19.5 2.50039Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 12H10M13 12C14.1046 12 15 11.1046 15 10C15 8.89543 14.1046 8 13 8H12M13 12C14.1046 12 15 12.8954 15 14C15 15.1046 14.1046 16 13 16H12M10 12V8M10 12V16M9 8H10M9 16H10M10 8H12M10 16H12M12 8V6.5M12 16V17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BitcoinRectangleIcon;
